import { render } from "./PreviewComposition.vue?vue&type=template&id=f81c5692&scoped=true&ts=true"
import script from "./PreviewComposition.vue?vue&type=script&lang=ts"
export * from "./PreviewComposition.vue?vue&type=script&lang=ts"

import "./PreviewComposition.vue?vue&type=style&index=0&id=f81c5692&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f81c5692"]])

export default __exports__